export class Notifier {

    static notificationsAllowed() {
        return window.Notification && Notification.permission === 'granted';
    }
}